module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-2-poster.8a2e42e0.jpg";